import React, { useState, lazy } from "react";
import "./mobileversion.css";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
// import Marquee from "react-fast-marquee";
import VideoItems from "./videoitems";
import { blogvisible } from "./main";
import CloseIcon from "@material-ui/icons/Close";
import { highlight, changeactive } from "../services";
// import VideoModal from "../../Sections/VideoGallery/VideoModal";
// import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ServiceForms from "./ServiceForms";
const Mobilecalculator = lazy(() =>
  import("./mobilecalculator/mobileCalculator")
);

function Mobileversion(props) {
  const [isexpanded, setisexpanded] = useState(false);
  const [isvideoopened, setisvideoopened] = useState(false);
  const [formOpened, setFormOpened] = useState(false);
  const [calculatoropened, setcalculatoropened] = useState(false);
  const [showVideoGallery, setShowVideGallery] = useState(false);
  const [currentVideo, setCurrentVideo] = useState();
  function handleVideoGalleryModal() {
    setShowVideGallery(false);
  }
  const calculatorCloseHandler = () => {
    setcalculatoropened(false);
  };
  const formCloseHandler = () => {
    setFormOpened(false);
  };
  const calculatorOpenHandler = () => {
    setFormOpened(false);
    setcalculatoropened(true);
  };
  const formOpenHandler = () => {
    setcalculatoropened(false);
    setFormOpened(true);
  };

  // const [showVideoGallery, setShowVideGallery] = useState(false);
  // const [currentVideo, setCurrentVideo] = useState();
  // function setShowVideoGallery() {
  //   setShowVideGallery(true);
  // }
  // function handleVideoGalleryModal() {
  //   setShowVideGallery(false);
  // }
  // function setVideoGallery(url) {
  //   setCurrentVideo(url);
  // }

  return (
    <div id="mob_container" className="mob_container">
      <div className="mob_container_top">
        <div className="mob_top_title">
          {formOpened ? (
            <p>Forms</p>
          ) : (
            <p>
              {props.services.title} {props.services.id}/12
            </p>
          )}
          {calculatoropened && (
            <CloseIcon
              onClick={calculatorCloseHandler}
              className="calc__close-icon"
              style={{ fill: "blue", marginLeft: 0, marginRight: "auto" }}
            />
          )}
          {formOpened && (
            <CloseIcon
              onClick={formCloseHandler}
              className="calc__close-icon"
              style={{ fill: "blue", marginLeft: 0, marginRight: "auto" }}
            />
          )}
          {props.services.functions.length > 0 &&
            !calculatoropened &&
            !formOpened && (
              <div
                onClick={() => setisexpanded(!isexpanded)}
                className="addclosebutton"
              >
                {isexpanded ? <RemoveIcon /> : <AddIcon />}
              </div>
            )}
        </div>
      </div>
      {!calculatoropened && !formOpened && (
        <div
          className="d-flex flex-column"
          style={{ justifyContent: "space-evenly", flex: "1" }}
        >
          <div className="mob_middle_container">{props.service.content}</div>
          <div
            id="mob_top_contents"
            className={`mob_top_contents${!isexpanded ? " height" : ""}`}
          >
            {props.services.functions.map((elem, index) => {
              return (
                <p
                  key={index}
                  id={`maincat${index}`}
                  onClick={() => {
                    setisvideoopened(false);
                    props.setdesc(elem.description);
                    highlight(index);
                  }}
                >
                  {elem.title}
                </p>
              );
            })}
          </div>

          <div
            className={`d-flex flex-row mob_bottom_description ${
              isvideoopened ? "" : "service_area_video_opened"
            }`}
          >
            {isvideoopened && <VideoItems />}
            {/* {isvideoopened && (
              <OwlCarousel
                items={2}
                autoplay={true}
                margin={12}
                dots={false}
                // nav={true}
                loop
              >
                {WebsiteText.video.map((item, index) => {
                  return (
                    <VideoItem
                      key={index}
                      isservice={true}
                      data={item}
                      setShowVideoGalleryStatus={setShowVideoGallery}
                      setVideoGallery={setVideoGallery}
                    />
                  );
                })}
              </OwlCarousel>

              // <Marquee
              //   className="vidmarquee"
              //   pauseOnClick={true}
              //   gradient={false}
              //   speed={"30"}
              //   style={{ padding: "10px 10px" }}
              // >
              //   <div className="d-flex flex-row">
              //     {WebsiteText.video.map((item, index) => {
              //       return (
              //         <VideoItem
              //           key={index}
              //           isservice={true}
              //           data={item}
              //           setShowVideoGalleryStatus={setShowVideoGallery}
              //           setVideoGallery={setVideoGallery}
              //         />
              //       );
              //     })}
              //   </div>
              // </Marquee>
            )} */}
            <p className="m-0 px-1">{!isvideoopened && props.description}</p>
            {/* {props.services.functions.length > 0 && (
              <div className="mob_bottom_description">{props.description}</div>
            )} */}
          </div>
        </div>
      )}
      {calculatoropened && (
        <Mobilecalculator onClose={calculatorCloseHandler} />
      )}
      {formOpened && (
        <ServiceForms onCloseForms={formCloseHandler} mobileVersion={true} />
      )}
      <div className="footer_bar">
        <div className="btn-group dropup">
          <button
            type="button"
            className="btn btn-sm btn-secondary fb_button button-83"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Service
          </button>
          <div className="dropdown-menu">
            {props.serv1.map((elem) => {
              return (
                <button
                  key={elem.id}
                  id={`mobbutton${elem.id}`}
                  title={elem.title}
                  className="dropdown-item"
                  onClick={() => {
                    changeactive(elem.id);
                    props.mainContent(props.serv1[elem.id - 1]);
                  }}
                >
                  {elem.title}
                </button>
              );
            })}
          </div>
        </div>
        <div className="btn-group dropup">
          <button
            type="button"
            className="btn btn-sm btn-secondary fb_button button-83"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Resource
          </button>
          <div className="dropdown-menu">
            <button
              className="dropdown-item"
              onClick={() => blogvisible("open")}
            >
              Blog
            </button>
            <button
              className="dropdown-item"
              onClick={() => {
                setisvideoopened(true);
              }}
            >
              Video
            </button>
            <button className="dropdown-item" onClick={formOpenHandler}>
              Form
            </button>
            <button className="dropdown-item" onClick={calculatorOpenHandler}>
              Calculator
            </button>
          </div>
        </div>
        <div className="btn-group dropup">
          <div className="d-flex flex-column justify-content-start">
            <button
              type="button"
              className="btn btn-sm btn-secondary fb_button button-83"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Contact
            </button>
            <ul className="dropdown-menu dropdown-menu-right ref1 m-0">
              <ul className="list-inline d-flex">
                <li className="dropdown-item p-0 list-inline-item m-0">
                  <a
                    target="_self"
                    rel="noopener noreferrer"
                    href={`tel: +919292300345`}
                  >
                    {" "}
                    <i className="fa fa-phone"></i>
                  </a>
                </li>
                <li className="dropdown-item p-0 list-inline-item m-0">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      "https://api.whatsapp.com/send/?phone=9292300345&text&app_absent=0"
                    }
                  >
                    {" "}
                    <i className="fa fa-whatsapp"></i>
                  </a>
                </li>
                <li className="dropdown-item p-0 list-inline-item m-0">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://telegram.me/make05`}
                  >
                    {" "}
                    <i className="fa fa-telegram"></i>
                  </a>
                </li>
                <li className="dropdown-item p-0 list-inline-item m-0">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=samskrithigoshala@gmail.com"
                    }
                  >
                    {" "}
                    <i className="fa fa-envelope"></i>
                  </a>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mobileversion;
